import { Annotation } from '../interfaces/annotation.interface';

export interface GetTaskAnnotationsDto {
    annotations: Annotation[];
    totalCount: number;
}
